<template>
  <div class="page-wrap">
    <login
        v-if="isLogin"
        @click="isLogin = false"
    />
    <div v-else class="page-box-main">
      <header class="header">
        <div class="headercont">
          <div class="logo"><img src="https://static.rhkj.com/renhe_fe/other/303.png">
            <span class="city_name">（河南）</span>
            <span class="teaching-edition">实训平台教学版</span>
          </div>
          <div class="user_on"><span><a href="#">管理员</a></span>
            &nbsp;&nbsp;|&nbsp;&nbsp; <a href="#">退出</a></div>
        </div>

        <div class="menu-box">
          <div class="menu">
            <el-dropdown placement="bottom">
              <span class="item" style="cursor: pointer;"
                    @click="switchCom('首页')"
              >首页</span>
            </el-dropdown>

            <el-dropdown placement="bottom" popper-class="down-tax-dig-sajklda">
              <span class="item">抵扣勾选</span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                      v-if="props.currentQa.sonQueType == '41'"
                      @click="switchCom('发票抵扣勾选')"
                  >发票抵扣勾选
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="props.currentQa.sonQueType == '42'"
                      @click="switchCom('抵扣勾选统计')"
                  >抵扣勾选统计
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <el-dropdown placement="bottom">
              <span class="item">进项发票查询</span>
            </el-dropdown>

            <el-dropdown placement="bottom">
              <span class="item">税务事项通知书</span>
            </el-dropdown>

            <el-dropdown placement="bottom">
              <span class="item">发票管理</span>
            </el-dropdown>

            <el-dropdown placement="bottom">
              <span class="item">系统辅助功能</span>
            </el-dropdown>
          </div>
        </div>

      </header>

      <div class="bread">
        <img src="https://static.rhkj.com/renhe_fe/other/305.png"/>
        <div class="location">
          当前位置：首页
        </div>
        <div class="grow"></div>
        <img src="https://static.rhkj.com/renhe_fe/other/306.png"/>
      </div>

      <div class="gray-ge"></div>

      <main class="main-content">
        <component
            :is="componentView"
            :currentQa="currentQa"
        />
      </main>

      <footer class="footer">
        <div>
          监制单位：国家税务总局电子税务管理中心 研发单位：******
        </div>
        <div>
          支持火狐、谷歌、IE8以上版本浏览器 建议分辨率1280*768及以上 版本号： V4.0.00
        </div>
      </footer>

    </div>

  </div>
</template>

<script setup>
import Login from "./login.vue";
import checkInvoice from "./checkInvoice";
import statistConfirm from "./statistConfirm";
import home from './home.vue'

const isLogin = ref(true)

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const componentView = shallowRef(home);

function switchCom(name) {
  switch (name) {
    case '首页':
      componentView.value = home
      break
    case '发票抵扣勾选':
      componentView.value = checkInvoice
      break
    case '抵扣勾选统计':
      componentView.value = statistConfirm
      break
    default:
      componentView.value = null
      break
  }
}

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getResetData = () => {
  return {
    solution: ''
  }
}


</script>


<style scoped lang="scss">
.page-wrap {
  height: 100%;

  .page-box-main {
    height: 100%;
    overflow-y: auto;
    .header {
      width: 100%;
      background: linear-gradient(60deg, #26a2fb, #5ed6d7);

      .headercont {
        width: 1200px;
        margin: auto;
        padding: 10px 0;
        height: 94px;

        .logo {
          float: left;
          width: 650px;
          height: 94px;
          position: relative;

          .city_name {
            font-size: 24px;
            font-weight: 400;
            font-family: 'Microsoft YaHei';
            position: absolute;
            top: 32px;
            left: 370px;
            color: #fff;
            letter-spacing: 2px;
          }

          .teaching-edition {
            position: absolute;
            bottom: 8px;
            left: 66px;
            color: #f23232;
            letter-spacing: 5px;
            font-size: 16px;
          }
        }

        .user_on {
          float: right;
          margin-right: 20px;
          font-size: 14px;
          line-height: 94px;
          color: #FFFFFF;

          a {
            color: inherit;
          }
        }
      }

      .menu-box {
        background-image: url("https://static.rhkj.com/renhe_fe/other/304.png");

        .menu {
          width: 1200px;
          margin: auto;
          height: 45px;

          .item {
            line-height: 45px;
            font-size: 16px;
            color: #FFFFFF;
            padding: 0 30px;
            outline: none;
            border: none;

            &:hover {
              color: #FFFFFF;
              background: #0b608a;
            }
          }
        }
      }

    }

    .bread {
      padding: 20px 0 0 0;
      width: 1200px;
      margin: auto;
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;

      .location {
        margin-left: 20px;
      }

      .grow {
        flex-grow: 1;
      }
    }

    .gray-ge {
      width: 1200px;
      margin: auto;
      height: 15px;
      background-color: #f7f7f7;
    }

    .main-content {
      width: 1200px;
      margin: auto;
    }

    .footer {
      height: 60px;
      padding: 20px 0;
      background-color: #474747;
      color: #aaaaaa;
      line-height: 30px;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
.down-tax-dig-sajklda {
  margin-left: 74px;
  margin-top: -12px;

  .el-dropdown-menu {
    width: 270px;
    padding: 0;

    .el-dropdown-menu__item {
      background: #d9f1fd;
      padding: 7px 16px 7px 30px;
      color: #456;

      &:hover {
        color: #FFFFFF;
        background: #156593;
      }
    }
  }

  &.el-dropdown__popper.el-popper[data-popper-placement^=bottom] .el-popper__arrow:before {
    display: none;
    background-color: #d9f1fd;
  }
}
</style>
